export default __webpack_public_path__ + "assets/reward-placeholder.b20d614b45a54c2a0cedcc03d1b239b5.svg";